export const SP_MEDIA_QUERY = '(max-width: 767px)';

// SP: same-tab (default anchor navigation). PC: new tab, same as target="_blank".
// No `noopener` here: the terms page's own back button closes the tab via
// `window.opener`, which only same-origin `window.open` (without noopener) preserves.
// The destination is always same-site, so this carries no tabnabbing risk.
export function registerResponsiveTermsLinkHandler(target: Document = document): void {
  target.addEventListener('click', (event: MouseEvent) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const element = event.target;
    if (!(element instanceof Element)) {return;}
    const link = element.closest<HTMLAnchorElement>('a[data-responsive-new-tab]');
    if (!link) {return;}

    if (window.matchMedia(SP_MEDIA_QUERY).matches) {return;}

    event.preventDefault();
    window.open(link.href, '_blank');
  });
}
